import React from 'react';

interface AuthErrorBannerProps {
    error: string | null;
}

const AuthErrorBanner: React.FC<AuthErrorBannerProps> = ({ error }) => {
    if (!error) return null;

    return (
        <div className="fixed bottom-20 left-1/2 z-50 -translate-x-1/2">
            <div
                role="alert"
                className="rounded-sm border border-destructive/30 bg-destructive/10 px-4 py-2 font-mono text-xs text-destructive shadow-lg"
            >
                {error}
            </div>
        </div>
    );
};

AuthErrorBanner.displayName = 'AuthErrorBanner';

export default AuthErrorBanner;
